import "./styles.css";

export const PolicyStatusPill = ({ active }: { active: boolean }) => (
  <span
    className={`status-pill ${active ? "is-active" : "is-inactive"}`}
    aria-label={active ? "Active" : "Inactive"}
    title={active ? "Active" : "Inactive"}
  >
    {active ? "Active" : "Inactive"}
  </span>
);


export const NotificationStatusPill = ({ value }: { value?: string }) => {
  const v = (value ?? "").toUpperCase();
  const tone =
    v === "COMPLETED"
      ? "ok"
      : v === "STOP" || v === "STOPPED"
        ? "stop"
        : "muted";
  return <span className={`push-pill push-pill--${tone}`}>{v || "—"}</span>;
};